import { render, staticRenderFns } from "./NewPayrunModal.vue?vue&type=template&id=3f4818a6"
import script from "./NewPayrunModal.vue?vue&type=script&lang=js"
export * from "./NewPayrunModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports